import { DonutLegendChart } from '@/components/ui/DonutLegendChart';
import type { CategoryStats } from '../types/categoriesDetail.types';

interface CategoryStatsBlockProps {
  stats: CategoryStats[];
}

export function CategoryStatsBlock({ stats = [] }: CategoryStatsBlockProps) {
  const total = (stats || []).reduce((acc, curr) => acc + (curr?.value || 0), 0);
  const chartData = stats.map(s => ({
    name: s.label,
    value: s.value,
    color: s.color
  }));

  return (
    <DonutLegendChart
      title="Thống kê trạng thái con"
      centerValue={total}
      centerLabel="Tổng cộng"
      data={chartData}
      total={total}
    />
  );
}
